export default __webpack_public_path__ + "static/media/nykaa.e1fbe076.png";